import isNil from 'lodash/isNil'
import { ContentType } from '../content-type/types'
import { YOGA_INTENATIONAL_PATH_PREFIX } from './constants'

const ContentTypeToPathMap = {
  [ContentType.YI_CLASS]: 'class',
  [ContentType.YI_MEDITATION]: 'meditation',
  [ContentType.YI_COURSE]: 'course',
  [ContentType.YI_POSE]: 'pose',
  [ContentType.YI_ARTICLE]: 'article',
  [ContentType.YI_COURSE_SALES]: 'course-sales-page',
  [ContentType.YI_MEMBERSHIP_PROMO]: 'membership-promo',
  [ContentType.YI_HOMEPAGE_HERO]: 'homepage-hero-content',
  [ContentType.YI_SERIES]: 'series',
  [ContentType.YI_SERIES_EPISODE]: 'series',
  [ContentType.YI_TEACHER]: 'teacher',
  [ContentType.YI_TAG]: 'tag',
  [ContentType.YI_TAG_GROUP]: 'tag-group',
}

export function generateYIPath ({
  slug,
  language,
  yiContentType,
  seasonNumber,
  episodeNumber,
}: {
  language: string
  yiContentType: ContentType
  slug: string
  episodeNumber?: number | null
  seasonNumber?: number | null
}) {
  if (
    yiContentType === ContentType.YI_COURSE_SECTION ||
    yiContentType === ContentType.YI_COURSE_MODULE
  ) {
    return null
  }
  const contentTypePath = ContentTypeToPathMap[yiContentType]
  if (!isNil(contentTypePath)) {
    if (
      typeof seasonNumber === 'number' &&
      seasonNumber > 0 &&
      typeof episodeNumber === 'number' &&
      episodeNumber > 0
    ) {
      return `${YOGA_INTENATIONAL_PATH_PREFIX}/${language}/${contentTypePath}/${slug}/${seasonNumber}/${episodeNumber}`
    }
    return `${YOGA_INTENATIONAL_PATH_PREFIX}/${language}/${contentTypePath}/${slug}`
  }
  return null
}
